import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchPeriodicSurveys } from "../thunk/PeriodicSurveyThunk";

const initialData: any = [];

const PeriodicSurveysSlice: Slice<any, {}, "PeriodicSurveysSlice"> = createSlice({
    name: "PeriodicSurveysSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchPeriodicSurveys.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchPeriodicSurveys.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchPeriodicSurveys.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default PeriodicSurveysSlice;
